export default "<label>{{labelKey}}</label>\n<p>{{valueKey}}</p>\n";